import React, { useEffect, useState } from "react";
import { Grid, GridColumn, Message, Progress } from "semantic-ui-react";
import CustomerDetails from "../../BoxReview/components/CustomerDetails";
import ShippingImages from "../ShippingImages/ShippingImages";
import { useSelector } from "react-redux";
import Sidebar from "../Sidebar/Sidebar";
import WarningList from "../Sidebar/WarningList/WarningList";
import PickActions from "../PickActions/PickActions";
import ConfirmBoxButton from "../buttons/ConfirmBoxButton";
import SwapBoxButton from "../buttons/SwapBoxButton";
import RequestNewShippingLabelInAutomationButton from "../buttons/RequestNewShippingLabelInAutomationButton";
import InvalidBoxContentButton from "../buttons/InvalidBoxContentButton";
import ShippingList from "../ShippingList/ShippingList";
import ShippingMessageDisplay from "../ShippingMessageDisplay/ShippingMessageDisplay";
import { API_PATH } from "../../../utils/Constants";
import { conveyorBoxEndpoints } from "../../../lib/conveyorbox/endpoints";
import { getParamValue } from "../../../utils/UtilMethods";
import PrintNewLabelButton from "../buttons/PrintNewLabelButton";
import VerifyPickedItems from "../AutoVerifyAllItemsButton";
import { getStructuredBoxItems } from "../../../utils/helpers/conveyor-box";
import { useDispatch } from "react-redux";
import BarcodeScanner from "../BarcodeInput/BarcodeScanner";
import useVerifyItemsA2 from "../../../hooks/useVerifyItems/useVerifyItemsA2";
import { useBarcodeScanner } from "../../../hooks/useBarcodeScanner";

const POLLING_INTERVAL = 15000; // ms

const ShippingOverview = () => {
  const appState = useSelector<any, any>((state) => state.controlAppStateReducer);
  const conveyorBoxReview = useSelector((state: any) => state.conveyorBoxReviewReducer);
  const shipping = conveyorBoxReview.shipping;
  const labelUrl = !!conveyorBoxReview.boxBarcode
    ? API_PATH + "/api/review/label?boxBarcode=" + conveyorBoxReview.iPackBoxBarcode
    : "";

  const shouldShowPrintNewLabelButton = () => {
    const allowedWorkstationIds = ["1", "7209", "100"];

    let currentWorkstationId = getParamValue("ws");

    return allowedWorkstationIds.includes(currentWorkstationId);
  };

  const [imageBytes, setImageBytes] = useState<string | null>(null);
  useEffect(() => {
    if (imageBytes) return;

    const fetchImage = async () => {
      try {
        const data = await conveyorBoxEndpoints.loadContentImage(conveyorBoxReview.boxBarcode);
        if (data?.imageBytes) {
          setImageBytes(data.imageBytes);
        }
      } catch (err) {
        console.error("Failed to fetch image:", err);
      }
    };

    fetchImage();

    const intervalId = setInterval(fetchImage, POLLING_INTERVAL);

    return () => clearInterval(intervalId);
  }, [conveyorBoxReview.boxBarcode, imageBytes]);

  const { otc, bundles } = getStructuredBoxItems(conveyorBoxReview.items.active);
  const unverifiedBags = bundles.filter(
    (item) =>
      item.verifiedQuantity < item.confirmedQuantity &&
      (item.attributes.includes("RX") || item.attributes.includes("RXBAG"))
  );

  const { onVerifyItemByBarcode, onVerifyRxBagByBarcode } = useVerifyItemsA2({
    items: conveyorBoxReview.items.active,
  });
  const { onExecuteHigherOrderHandlerOrDefault } = useBarcodeScanner();

  return (
    <>
      <main className="control-app__content">
        {shipping && (
          <Grid columns={2}>
            <GridColumn>
              <ShippingMessageDisplay
                shipping={shipping}
                imageFound={conveyorBoxReview.imageFound}
                validationResult={conveyorBoxReview.validationResult}
                hasRX={conveyorBoxReview.items.active.some((item: any) =>
                  item.attributes.includes("RX")
                )}
              />

              {/* <ShippingsList
              printShipping={null}
              printCopy={false}
              isEditable={false}
              shippings={conveyorBoxReview.shippings}
              invoiceItems={conveyorBoxReview.invoice.items}
              shippingMethods={[]} //shippingMethods
            /> */}
              <ShippingList
                items={[...bundles, ...otc]}
                shippingId={shipping.id}
                shippingStatus={shipping.status}
                packageNumber={shipping.packageNumber}
              />
            </GridColumn>
            <GridColumn>
              <CustomerDetails
                currentBox={{
                  orderNumber: conveyorBoxReview.orderNumber,
                  invoiceNumber: conveyorBoxReview.invoice,
                  orderShopID: 6,
                  boxBarcode: conveyorBoxReview.boxBarcode,
                  sortType: -1,
                  workstationType: -1,
                  packedByInfo: {
                    operatorID: -1,
                    operatorName: "maximilian was here",
                    prefill: false,
                  },
                  addressFormatted: conveyorBoxReview.shipping.shippingAddressFormatted || "",
                  prefill: null,
                }}
              />
              {imageBytes && (
                <ShippingImages
                  imageBytes={imageBytes}
                  boxBarcode={conveyorBoxReview.boxBarcode}
                  labelUrl={labelUrl}
                />
              )}
            </GridColumn>
          </Grid>
        )}
      </main>

      <Sidebar show={conveyorBoxReview.orderNumber !== -1}>
        {/* <OrderInformation /> */}
        <WarningList />
        <PickActions>
          {(appState.isForcedRxBagVerification && !appState.isForcedRxBagVerificationFinished) ||
          (appState.isForcedRxBagVerification && !appState.isBoxSwapFinished) ? (
            <>
              <Message
                error
                icon="warning sign"
                header="Verifiering krävs"
                content="Lådan innehåller RX – vänligen öppna lådan och verifiera innehållet."
                style={{ gridColumn: "1 / -1", marginBottom: "1rem" }}
              />
              <div>
                <Progress
                  size="large"
                  value={bundles.length - unverifiedBags.length}
                  total={bundles.length}
                  progress="ratio"
                  color={"green"}
                  active={true}
                  disabled={false}
                ></Progress>
              </div>
              <div>
                <SwapBoxButton disabled={unverifiedBags.length > 0} />
              </div>
              <BarcodeScanner
                onScan={async (value, format) => {
                  return onExecuteHigherOrderHandlerOrDefault(
                    value,
                    format,
                    onVerifyRxBagByBarcode
                  );
                }}
              />
            </>
          ) : (
            <>
              <VerifyPickedItems />
              <InvalidBoxContentButton />
              {shouldShowPrintNewLabelButton() && <PrintNewLabelButton />}
              <RequestNewShippingLabelInAutomationButton />
              <SwapBoxButton />
              <BarcodeScanner
                onScan={async (value, format) => {
                  return onExecuteHigherOrderHandlerOrDefault(value, format, () => {});
                }}
              />
            </>
          )}
          <ConfirmBoxButton />
        </PickActions>
      </Sidebar>
    </>
  );
};

export default ShippingOverview;
